<template>
  <div>
    <h4 class="ui dividing header">{{ $t("setup") }}</h4>
    <div class="fields">
      <div class="field">
        <label for="">{{ $t("host") }}</label>
        <input type="text" name="host" v-model="setup.host" />
      </div>
      <div class="field">
        <label for="">{{ $t("port") }}</label>
        <input type="text" name="port" v-model="setup.port" />
      </div>
      <div class="field">
        <div class="ui toggle checkbox">
          <input type="checkbox" name="secure" v-model="setup.secure" />
          <label>{{ $t("secure") }}</label>
        </div>
      </div>
      <div class="field">
        <div class="ui toggle checkbox">
          <input type="checkbox" name="is_gmail" v-model="setup.is_gmail" />
          <label>{{ $t("gmail") }}</label>
        </div>
      </div>
    </div>
    <h5 class="ui dividing header">{{ $t("authentication") }}</h5>
    <div class="two fields">
      <div class="field">
        <label for="">{{ $t("user") }}</label>
        <input type="text" name="ip_pool" v-model="setup.auth.user" />
      </div>
      <div class="field">
        <label for="">{{ $t("password") }}</label>
        <input type="password" name="api_key" v-model="setup.auth.pass" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Mandrill",
  data() {
    return {
      setup: {
        host: "",
        port: "",
        secure: false,
        gmail: false,
        auth: { user: "", pass: "" },
      },
    };
  },
  methods: {
    getSetup() {
      return this.setup;
    },
    setSetup(setup) {
      return (this.setup = setup);
    },
  },
};
</script>
